module.exports = __webpack_public_path__ + "media/src/images/lp/lp-back-8a675df5286137004110dec1b3212753.jpg";